import { AllRoutes } from "./routes/AllRoutes";
import { Header } from "./components";
import './App.css';


function App() {
  return (
    <div>
      <Header />
      <AllRoutes />
    </div>
  );
}

export default App;
